import { Alert, Snackbar } from '@mui/material';
import { useState } from 'react';

export type Severity = 'success' | 'error' | 'info' | 'warning';

const AgSnack = ({ msg, severity, onClose }: { msg: string; severity?: Severity; onClose?: () => void }) => {
  const [open, setOpen] = useState(true);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        variant='filled'
        severity={
          severity === 'error' ? 'error'
            : severity === 'info' ? 'info'
              : severity === 'warning' ? 'warning'
                : 'success'}>{msg}</Alert>
    </Snackbar>
  );
};

export default AgSnack;